import React, {FunctionComponent} from "react";
import {ToggleButton, ToggleButtonGroup, Typography} from "@mui/material";
import {UnavailabilityChartMode} from "../utils/UnavailabilityChartUtils";
import themeDefaults from "../../../../Shared/Theme/ThemeDefaults";

const options: {value: UnavailabilityChartMode, label: string}[] = [
    {value: 'TOTAL', label: 'Totais'},
    {value: 'DIN', label: 'DIN'},
];

const UnavailabilityModeToggle: FunctionComponent<{
    value: UnavailabilityChartMode,
    onChange: (mode: UnavailabilityChartMode) => void
}> = ({value, onChange}) => {
    // Sempre há uma opção selecionada: clicar na opção ativa (newValue null) não altera o modo.
    const handleChange = (_event: React.MouseEvent<HTMLElement>, newValue: UnavailabilityChartMode | null) => {
        if (newValue && newValue !== value) onChange(newValue);
    };

    return (
        <ToggleButtonGroup
            size="small"
            exclusive
            value={value}
            onChange={handleChange}
            aria-label="Tipo de perda"
            sx={{height: '38px'}}
        >
            {options.map((option) => (
                <ToggleButton
                    key={option.value}
                    value={option.value}
                    aria-label={option.label}
                    sx={{
                        borderRadius: '8px',
                        height: '38px',
                        px: 1.25,
                        '&.Mui-selected, &.Mui-selected:hover': {
                            backgroundColor: themeDefaults.colors.primary,
                            color: 'white',
                        },
                    }}
                >
                    <Typography sx={{textTransform: 'uppercase', fontSize: '12px', fontWeight: 500}}>{option.label}</Typography>
                </ToggleButton>
            ))}
        </ToggleButtonGroup>
    );
};

export default UnavailabilityModeToggle;
